import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormikContext } from 'formik';
import { observer } from 'mobx-react-lite';
import { Column } from '~/views/atoms/boxes';
import { FormikCheckbox } from '~/views/atoms/formik-checkbox/formik.checkbox';
import { Box } from '@mui/material';
import { t } from 'i18next';
import { ServiceCategoryTag } from '~/services/service.category.tag';
import { useService } from '~/services/service.base';
export const FormMediaFilter = observer(() => {
    const formik = useFormikContext();
    const serviceCategoryTag = useService(ServiceCategoryTag);
    return (_jsxs(Column, { gap: 2, children: [_jsx(Box, { fontWeight: "600", children: t('MEDIAS_FILTERS_TAGS') }), serviceCategoryTag.tags.map(tag => (_jsx(FormikCheckbox, { formikProps: formik, name: tag.value, label: tag.label }, tag.value)))] }));
});
